export function cashDueForOrder(order) {
  const budget = Number(order?.budget ?? 0);
  const runnerFee = order?.local_offer_id ? Number(order.runner_fee ?? 0) : 0;
  return budget + runnerFee;
}
